// ===================================================
// FISCAL — TABS (NFS-e Emitidas / Notas Tomadas)
// ===================================================
let _fiscalTab='emitidas';
function switchFiscalTab(tab){
  _fiscalTab=tab;
  ['emitidas','tomadas'].forEach(t=>{
    const btn=document.getElementById('fiscal-tab-'+t);
    const panel=document.getElementById('fiscal-panel-'+t);
    if(btn)btn.classList.toggle('active',t===tab);
    if(panel)panel.style.display=t===tab?'':'none';
  });
  const novoBtn=document.getElementById('fiscal-novo-btn');
  if(novoBtn)novoBtn.style.display=tab==='tomadas'?'':'none';
  if(tab==='tomadas'){initMesSelect('nt-mes');renderNotasTomadas();}
}
function renderNotasTomadas(){
  initMesSelect('nt-mes');
  const mes=document.getElementById('nt-mes')?.value||'';
  const q=(document.getElementById('nt-search')?.value||'').toLowerCase();
  const cat=document.getElementById('nt-cat')?.value||'';
  let notas=[...DB.get('notas_tomadas')].sort((a,b)=>(b.dataEmissao||'').localeCompare(a.dataEmissao||''));
  if(mes)notas=notas.filter(n=>n.dataEmissao&&n.dataEmissao.startsWith(mes));
  if(cat)notas=notas.filter(n=>n.categoria===cat);
  if(q)notas=notas.filter(n=>(n.cnpjEmissor||'').includes(q)||(n.razaoSocial||'').toLowerCase().includes(q)||(n.numNota||'').includes(q)||(n.desc||'').toLowerCase().includes(q));
  const totalVal=notas.reduce((s,n)=>s+geoNum(n.valor),0);
  const cats={materiais:0,servicos:0,equipamentos:0,logistica:0,administrativo:0,outros:0};
  notas.forEach(n=>cats[n.categoria||'outros']=(cats[n.categoria||'outros']||0)+geoNum(n.valor));
  const topCat=Object.entries(cats).sort((a,b)=>b[1]-a[1]).filter(([,v])=>v>0).slice(0,2).map(([k,v])=>`${k}: ${fmt(v)}`).join(' · ');
  document.getElementById('nt-cards').innerHTML=`
    <div class="card accent"><label>Total notas tomadas</label><div class="val">${notas.length}</div><div class="sub">${fmt(totalVal)}</div></div>
    <div class="card"><label>Mês selecionado</label><div class="val">${notas.length}</div><div class="sub">${mes?fmtMesAno(mes):'Todos os meses'}</div></div>
    <div class="card"><label>Por categoria</label><div class="val" style="font-size:14px">${topCat||'—'}</div></div>`;
  const tbody=document.getElementById('tabela-nt');
  if(!notas.length){tbody.innerHTML='<tr><td colspan="7" class="empty">Nenhuma nota tomada registrada. Clique em "+ Registrar nota" para adicionar.</td></tr>';return;}
  const catLabel={materiais:'Materiais',servicos:'Serviços',equipamentos:'Equipamentos',logistica:'Logística',administrativo:'Administrativo',outros:'Outros'};
  tbody.innerHTML=notas.map(n=>`<tr>
    <td><strong>${escapeHtml(n.razaoSocial||'—')}</strong><br><small style="color:var(--muted);font-family:monospace">${escapeHtml(n.cnpjEmissor||'—')}</small></td>
    <td>${escapeHtml(n.numNota||'—')}</td>
    <td>${fmtD(n.dataEmissao)}</td>
    <td style="font-weight:600">${fmt(n.valor)}</td>
    <td><span class="badge">${catLabel[n.categoria]||n.categoria||'—'}</span></td>
    <td style="max-width:200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis" title="${escapeHtml(n.desc||'')}"><small>${escapeHtml(n.desc||'—')}</small></td>
    <td><button class="btn btn-ghost btn-sm" onclick="openNotaTomadaForm('${n.id}')">✏️</button></td>
  </tr>`).join('');
}
function openNotaTomadaForm(id){
  const n=id?DB.get('notas_tomadas').find(x=>x.id===id):null;
  document.getElementById('nt-id').value=n?.id||'';
  document.getElementById('nt-cnpj').value=n?.cnpjEmissor||'';
  document.getElementById('nt-razao').value=n?.razaoSocial||'';
  document.getElementById('nt-numero').value=n?.numNota||'';
  document.getElementById('nt-data').value=n?.dataEmissao||today();
  document.getElementById('nt-valor').value=n?.valor||'';
  document.getElementById('nt-categoria').value=n?.categoria||'materiais';
  document.getElementById('nt-desc').value=n?.desc||'';
  document.getElementById('nt-obs').value=n?.obs||'';
  const excBtn=document.getElementById('nt-excluir-btn');
  if(excBtn)excBtn.style.display=n?'':'none';
  openModal('modal-nota-tomada');
}
async function salvarNotaTomada(){
  const cnpj=document.getElementById('nt-cnpj').value.trim();
  const razao=document.getElementById('nt-razao').value.trim();
  const numNota=document.getElementById('nt-numero').value.trim();
  const dataEmissao=document.getElementById('nt-data').value;
  const valor=parseFloat(document.getElementById('nt-valor').value)||0;
  if(!razao||!dataEmissao||!valor){toast('Preencha razão social, data e valor','error');return;}
  const eid=document.getElementById('nt-id').value;
  const lista=[...DB.get('notas_tomadas')];
  const obj={id:eid||uid(),cnpjEmissor:cnpj,razaoSocial:razao,numNota,dataEmissao,valor,categoria:document.getElementById('nt-categoria').value,desc:document.getElementById('nt-desc').value.trim(),obs:document.getElementById('nt-obs').value.trim(),createdAt:eid?lista.find(x=>x.id===eid)?.createdAt:new Date().toISOString(),updatedAt:new Date().toISOString()};
  if(eid){const i=lista.findIndex(x=>x.id===eid);if(i>=0)lista[i]=obj;else lista.unshift(obj);}else lista.unshift(obj);
  await DB.set('notas_tomadas',lista);
  closeModal('modal-nota-tomada');renderNotasTomadas();toast('Nota tomada salva ✓');
}
async function deleteNotaTomada(id){
  if(!id)return;
  const n=DB.get('notas_tomadas').find(x=>x.id===id);
  if(!n||!await uiConfirm({tone:'danger',eyebrow:'Documento fiscal',title:`Excluir nota ${n.numNota||'s/n'}?`,message:n.razaoSocial||'Fornecedor não informado',impact:'A nota tomada será removida do controle fiscal e financeiro.',confirmLabel:'Excluir nota'}))return;
  const lista=DB.get('notas_tomadas').filter(x=>x.id!==id);
  await DB.set('notas_tomadas',lista);
  closeModal('modal-nota-tomada');renderNotasTomadas();toast('Nota excluída');
}
async function _buscarCNPJNota(cnpj){
  const c=cnpj.replace(/\D/g,'');if(c.length!==14)return;
  const razaoEl=document.getElementById('nt-razao');if(razaoEl&&razaoEl.value)return;
  try{
    const r=await fetch(`https://brasilapi.com.br/api/cnpj/v1/${c}`);
    if(!r.ok)return;
    const d=await r.json();
    if(razaoEl&&!razaoEl.value)razaoEl.value=d.razao_social||d.nome_fantasia||'';
  }catch(e){}
}
function fmtMesAno(yyyymm){const [y,m]=yyyymm.split('-');const nomes=['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];return (nomes[parseInt(m)-1]||m)+'/'+y;}

